export default {
  labels: {
    card: 'Luottokortti',
    bank_account: 'Pankkitili',
  },
  alerts: {
    payments_not_configured:
      'Maksuja ei ole vielä määritetty. Ota yhteyttä palveluntarjoajaasi maksujen käyttöön ottamiseksi ja palaa sitten tähän vaiheeseen.',
  },
  buttons: {
    change_payment_method: 'Vaihda maksutapaa',
    save_payment_info: 'Tallenna maksutiedot',
  },
  toasts: {
    failed_to_init_payment_setup: 'Maksun asetusprosessin käynnistäminen epäonnistui, lataa sivu uudelleen',
    successfully_saved_payment_method: 'Maksutiedot tallennettiin',
  },
};
